import type { Dropdown as DropdownA } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';

type ClassNames = ComponentProps<typeof DropdownA>['classNames'];

export const resolveClassNames = (classNames: ClassNames, rootClassName?: string, iconClassName?: string) =>
  typeof classNames === 'function'
    ? (info: Parameters<NonNullable<typeof classNames>>[0]) => {
        const resolved = classNames(info);

        return {
          ...resolved,
          itemIcon: cn(iconClassName, resolved?.itemIcon),
          root: cn(rootClassName, resolved?.root),
        };
      }
    : {
        ...classNames,
        itemIcon: cn(iconClassName, classNames?.itemIcon),
        root: cn(rootClassName, classNames?.root),
      };
